import styles from './EditNavBar.module.scss'
import { Icon } from 'components/Icon/Icon'
import { Button } from 'components/Button/Button'
import classnames from 'classnames'
import { useIsMobile } from 'hooks/useIsMobile'


type Props = {
    onClose?: () => void,
    isDataChanged?: boolean,
    onSubmit?: () => void,
    onDiscard?: () => void,
}

export function EditNavBar(props: Props) {
    const { isMobile } = useIsMobile()

    function navigateTo() {
        window.open('http://localhost:3000/deposit', '_blank')
    }

    function handleSubmit() {
        // handle submit
        props.onSubmit()
    }

    function handleDiscard() {
        // handle discard
        props.onDiscard()
    }

    const navbarClassName = classnames({
        [styles['container']]: true,
        [styles['container_active']]: props.isDataChanged
    })

    return (
        <div className={navbarClassName}>
            <div className={styles['content']}>
                <div className={styles['header']}>
                    <div className={styles['cross']} onClick={props.onClose}>
                        <Icon name='cross' />
                    </div>
                    <div className={styles['title']}>
                        My Drizzle page
                    </div>
                </div>
                {(!isMobile || (isMobile && !props.isDataChanged)) && (
                    <Button
                        size='s'
                        type='dark'
                        iconName='external'
                        iconRight={true}
                        stretch={false}
                        onClick={navigateTo}
                    >
                        View page
                    </Button>
                )}
            </div>
            {props.isDataChanged && (
                <div className={styles['content_extra']}>
                    <>
                        <span className={styles['info']}>
                            You have unpublished changes
                        </span>
                        <Button
                            size='s'
                            type='border'
                            stretch={false}
                            onClick={handleDiscard}
                        >
                            Discard
                        </Button>
                        <Button
                            size='s'
                            type='primary'
                            stretch={false}
                            onClick={handleSubmit}
                        >
                            Save & Publish
                        </Button>
                    </>
                </div >
            )}
        </div >
    )
}

